/* eslint max-classes-per-file: 0 */

import {
  PublicationStorage as Data,
  PublicationStorageCollection as Collection,
} from '@/typings/api/Publication'
import { PublicationsStorageApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationStorageTransformerParams extends TransformerParams {
  protected defaultParams = ['publication_id'];
}

export class PublicationStorageAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationStorageTransformerParams();
}
